import React, { useContext, ReactNode, PropsWithChildren, useEffect } from "react";
import Image from "next/image";
import MultiSelectFormWraper from "./MultiSelectFormWraper";
import ProgressBar from "~/components/HeaderSlim/ProgressBar";
import { MultiSelectFormContext } from "~/contexts/MultiSelectForm";
import { WhatsappButton } from "./styles";
import Tippy from "@tippyjs/react";

import "tippy.js/dist/tippy.css";
import Footer from "~/components/Footer";
import Timeline from "./CategoryForm/TimeLine";

type MultiStepFormProps = {
    goToStep: (step: number) => void;
    prevStep: () => void;
    nextStep: () => void;
    currentStep: number;
    children?: ReactNode;
    utmSource: string;
};

const MultiStepForm = ({ children, goToStep, nextStep, currentStep, prevStep, utmSource }: MultiStepFormProps) => {
    const { setTotalSteps, updateStepStorage } = useContext(MultiSelectFormContext);
    const totalSteps = React.Children.count(children);

    const CurrentStepComponent = React.cloneElement(
        children[currentStep - 1] as React.ReactElement<PropsWithChildren<MultiStepFormProps>>,
        {
            goToStep,
            nextStep,
            prevStep,
            currentStep,
            utmSource,
        }
    );

    useEffect(() => {
        updateStepStorage("totalSteps", totalSteps);
        setTotalSteps(totalSteps);
    }, []);

    const steps = ["Segmento", "Data e Local", "Revisão", currentStep === 4 ? "Publicado" : "Publicar"];

    return (
        <>
            {/* <ProgressBar currentStep={currentStep} totalSteps={totalSteps} /> */}
            <Timeline currentStep={currentStep} steps={steps} />
            <MultiSelectFormWraper>{CurrentStepComponent}</MultiSelectFormWraper>
            <a
                href="https://wa.me/5511994536785?text=Ol%C3%A1,%20queria%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20marketplace"
                target="_blank"
            >
                <Tippy content="Contate-nos">
                    <WhatsappButton step={currentStep}>
                        <Image src="/images/whatsapp.svg" width={40} height={40} />
                    </WhatsappButton>
                </Tippy>
            </a>
            <Footer />
        </>
    );
};

export default MultiStepForm;
